import React, { forwardRef } from 'react';
import styles from './Form.module.css';
import {
  Form as FormAria,
  FormProps as FormAriaProps,
} from 'react-aria-components';
import { cva } from 'class-variance-authority';

const form = cva(styles['form'], {
  variants: {
    maxWidth: {
      default: styles['form--default'],
      fullWidth: styles['form--fullWidth'],
    },
    defaultVariants: { maxWidth: 'default' },
  },
});

export interface FormProps extends FormAriaProps {
  children?: React.ReactNode;
  /**
   * Controls the maximum width of the form container
   * Default is a constrained width defined by the design token (`--alto-form-max-width`)
   * @default "default"
   */
  maxWidth?: 'default' | 'fullWidth';
  /**
   * Test ID for the component, used for testing purposes
   */
  'data-testid'?: string;
}

export const Form = forwardRef<HTMLFormElement, FormProps>(
  (
    { children, maxWidth = 'default', 'data-testid': dataTestId, ...props },
    forwardedRef,
  ) => {
    return (
      <FormAria
        className={form({ maxWidth })}
        {...props}
        ref={forwardedRef}
        data-testid={dataTestId}
      >
        {children}
      </FormAria>
    );
  },
);
Form.displayName = 'Form';

export default Form;
